/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawersChangeRef,
  CashDrawersChangeRefOptional,
  CashDrawersChangeRefMetaI,
  CashDrawersChangeRefTrackedI,
} from "./cash-drawers-change-ref";
import {
  CashDrawersChangeRefTracked,
  CashDrawersChangeRefMeta,
} from "./cash-drawers-change-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashTransactionBase,
  CashTransactionBaseOptional,
  CashTransactionBaseMetaI,
  CashTransactionBaseTrackedI,
} from "./cash-transaction-base";
import {
  CashTransactionBaseTracked,
  CashTransactionBaseMeta,
} from "./cash-transaction-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashTransactionRef,
  CashTransactionRefOptional,
  CashTransactionRefMetaI,
  CashTransactionRefTrackedI,
} from "./cash-transaction-ref";
import {
  CashTransactionRefTracked,
  CashTransactionRefMeta,
} from "./cash-transaction-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";

/**
 *
 * @export
 * @interface CashTransactionFull
 */
export interface CashTransactionFullOptional extends CashTransactionBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {CashDrawersChangeRef}
   * @memberof CashTransactionFull
   */
  cashDrawerChangeId?: CashDrawersChangeRefOptional;
}

export interface CashTransactionFull
  extends
    CashTransactionFullOptional,
    CashTransactionBase,
    CashTransactionRef,
    Deletable {
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  transactionAmountCents: number;
  /**
   *
   * @type {CashDrawersChangeRef}
   * @memberof CashTransactionFull
   */
  cashDrawerChangeId?: CashDrawersChangeRef;
}

export interface CashTransactionFullTrackedI extends CashTransactionBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashTransactionFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashTransactionFull
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {CashDrawersChangeRef}
   * @memberof CashTransactionFull
   */
  cashDrawerChangeId?: CashDrawersChangeRefTrackedI;
  cashDrawerChangeIdIsSet: boolean;
}

transformDatesMap.set(
  "CashTransactionFull",
  function (model: CashTransactionFull) {
    const transformDatescashDrawerChangeId = transformDatesMap.get(
      "CashDrawersChangeRef",
    );
    if (transformDatescashDrawerChangeId && model.cashDrawerChangeId) {
      transformDatescashDrawerChangeId(model.cashDrawerChangeId);
    }
  },
);

export type CashTransactionFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cashDrawerChangeId: PropertyMeta<CashDrawersChangeRefMetaI>;
}>;

export var CashTransactionFullMeta: CashTransactionFullMetaI =
  {} as CashTransactionFullMetaI;
CashTransactionFullMeta = typeMeta("CashTransactionFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  cashDrawerChangeId: propertyMeta(
    "cashDrawerChangeId",
    false,
    false,
    false,
    CashDrawersChangeRefMeta,
  ),
});

const metaI = CashTransactionFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([CashTransactionRefMeta]);
  metaI.assignId.inheritedFrom = CashTransactionRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([CashTransactionBaseMeta]);
  metaI.transactionAmountCents.inheritedFrom =
    CashTransactionBaseMeta.transactionAmountCents;
});

export class CashTransactionFullTracked
  extends CashTransactionBaseTracked
  implements CashTransactionFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  cashDrawerChangeId__I?: CashDrawersChangeRefTracked = undefined;
  cashDrawerChangeIdIsSet: boolean = false;
  set cashDrawerChangeId(v: undefined | CashDrawersChangeRefTracked) {
    if (v !== undefined) {
      this.cashDrawerChangeId__I = v;
      this.cashDrawerChangeIdIsSet = true;
    } else {
      this.cashDrawerChangeId__I = v || undefined;
      this.cashDrawerChangeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawerChangeId() {
    return this.cashDrawerChangeId__I;
  }
  constructor(config?: CashTransactionFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.cashDrawerChangeId?.setIds();
  }
  assignFrom(
    config: CashTransactionFullOptional,
    options?: AssignOptions,
  ): CashTransactionFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.cashDrawerChangeId &&
      this.cashDrawerChangeIdApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerChangeId = new CashDrawersChangeRefTracked(
        config.cashDrawerChangeId,
        options,
      );
      if (optionsRequired.unassign) this.cashDrawerChangeIdIsSet = false;
      else this.cashDrawerChangeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashTransactionFullTrackedI {
    const cloned = {} as CashTransactionFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.cashDrawerChangeIdIsSetDeep() &&
      this.cashDrawerChangeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerChangeIdIsSet = true;
      cloned.cashDrawerChangeId = this.cashDrawerChangeId?.removeUnset(filter);
    } else {
      //cloned.cashDrawerChangeIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashTransactionFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.cashDrawerChangeIdApplyFilter(filter))
      this.cashDrawerChangeIdIsSet = false;
    this.cashDrawerChangeId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashTransactionFullMeta.isDeleted,
      CashTransactionFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashTransactionFullMeta.isNew,
      CashTransactionFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashTransactionFullMeta.assignId,
      CashTransactionFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashTransactionFullMeta.transactionAmountCents,
      CashTransactionFullMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  cashDrawerChangeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashTransactionFullMeta.cashDrawerChangeId,
      CashTransactionFullMeta,
      this.cashDrawerChangeId,
      this,
    );
  }
  cashDrawerChangeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cashDrawerChangeIdIsSet &&
      this.cashDrawerChangeIdApplyFilter(filter)
    )
      return true;
    return this.cashDrawerChangeId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.cashDrawerChangeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
